'use strict';

(function (factory) {
    //这个写法是我了同时兼容浏览器端和nodejs服务端。
    if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        define('validate_config', [], function () {
            return factory();
        });
    }
})(function () {
    var ValidateConfig = {};

    ValidateConfig.VALID_PASSWORD_REGEX = /^[^ ]+$/;
    ValidateConfig.VALID_NEW_PASSOWRD_REGEX = /^[!"#\$%&'\(\)\*\+,-\.\/\\:;<=>\?@\[\]\^_`\{\|\}~A-Z0-9a-z]{6,18}$/;
    ValidateConfig.VALID_PHONE_REGEX = /^1[\d]{10}$/;
    ValidateConfig.VALID_ABROAD_PHONE_REGEX = /^[\d]{6,20}$/;
    ValidateConfig.VALID_VERIFY_CODE_REGEX = /^[0-9]{1,6}$/;
    ValidateConfig.VALID_USERNAME_OR_PHONE_REGEX = /^\+?[A-Z0-9a-z]{6,20}$/;
    ValidateConfig.VALID_NICKNAME_REGEX = /^[\u4e00-\u9fa5A-Z0-9a-z]{1,10}$/;

    ValidateConfig.PASSWORD_LOGIN_FORM_CONFIG = {
        rules: {
            username: {
                required: true,
                regexp: ValidateConfig.VALID_USERNAME_OR_PHONE_REGEX,
            },
            password: {
                required: true,
                regexp: ValidateConfig.VALID_PASSWORD_REGEX,
            },
        },
        messages: {
            username: {
                required: '请输入手机号或账号',
                regexp: '请输入6-20位英文或数字组合',
            },
            password: {
                required: '请输入密码',
                regexp: '密码不能使用空格',
            },
        },
    };

    ValidateConfig.VERIFY_CODE_LOGIN_FORM_CONFIG = {
        rules: {
            phone: {
                required: true,
                regexp: ValidateConfig.VALID_PHONE_REGEX,
            },
            verificationCode: {
                required: true,
                regexp: ValidateConfig.VALID_VERIFY_CODE_REGEX,
            },
        },
        messages: {
            phone: {
                required: '请输入手机号',
                regexp: '请输入11位手机号',
            },
            verificationCode: {
                required: '请输入验证码',
                regexp: '请输入最多6位数字',
            },
        },
    };

    ValidateConfig.FORGET_PASSWORD_FORM_CONFIG = {
        rules: {
            areaCode: {
                required: true,
            },
            phone: {
                required: true,
                regexp: ValidateConfig.VALID_PHONE_REGEX,
            },
            verificationCode: {
                required: true,
                regexp: ValidateConfig.VALID_VERIFY_CODE_REGEX,
            },
            newPassword: {
                required: true,
                regexp: ValidateConfig.VALID_PASSWORD_REGEX,
            },
        },
        messages: {
            phone: {
                required: '请输入手机号',
                regexp: '请输入11位手机号',
            },
            verificationCode: {
                required: '请输入验证码',
                regexp: '请输入最多6位数字',
            },
            newPassword: {
                required: '请输入新密码',
                regexp: '请设置6-18位密码，不能使用空格或非法字符',
            },
        },
    };

    ValidateConfig.FIRST_SETTING_FORM_CONFIG = {
        rules: {
            uid: {
                required: true,
            },
            nickname: {
                required: true,
                regexp: /^[\u4e00-\u9fa5A-Z0-9a-z]{1,10}$/,
            },
            password: {
                required: true,
                regexp: ValidateConfig.VALID_NEW_PASSOWRD_REGEX,
            },
            confirmPwd: {
                required: true,
                equalTo: '#setting-form [name=password]',
                regexp: ValidateConfig.VALID_NEW_PASSOWRD_REGEX,
            },
        },
        messages: {
            username: {
                required: '请输入昵称',
                regexp: '请输入中英文或数字，最多10字符',
            },
            password: {
                required: '请输入密码',
                regexp: '请设置6-18位密码，不能使用空格或非法字符',
            },
            confirmPwd: {
                required: '请再次输入密码',
                equalTo: '两次输入的密码不一致',
                regexp: '请设置6-18位密码，不能使用空格或非法字符',
            },
        },
    };

    return ValidateConfig;
});
